import React, { Fragment } from "react";
import { Link } from 'react-router-dom';

import "./AttributeSize.css";

class AttributeSize extends React.Component {
  constructor(props) {
    super(props);
    //this.toggleClass = this.toggleClass.bind(this);
    this.state = { imageActive: false };
  }

  render() {
    return (
      <Fragment>
        <div className="mn-grid__row mn-grid__row--gap-lg">
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial">
                <label for="" className="uk-form-label uk-flex uk-flex-between">انتخاب سایز کالا: <span className="uk-form-label__required"></span>
                    {/* <Link className="search-link" id="newSizeRequestModalBtn">درخواست سایز جدید</Link> */}
                </label>
                <div className="field-wrapper" id="attributesContainer">
                    <div className="mn-variant__attributes-container">
                        {this.props.sizesData.map((size, index) => (
                          <button type="button" 
                            className="mn-variant-btn js-add-variant" 
                            id={size.id}
                            data-attribute-value={size.title}
                            data-attribute-id={size.id} 
                            data-title={size.title}
                            onClick={this.props.onAddVariantSizeHandler.bind(this, {
                              id: size.id,
                              title: size.title,
                              index: index,
                          })}>
                              <span className="mn-variant-btn__label">
                                  <span className="mn-variant-btn__text">{size.title}</span>
                                  <span className={[ "mn-variant-btn__counter", `${size.count==0 && "hidden"}`, ].join(" ")}>
                                      (<span className="js-variant-count">{size.count}</span>)
                                  </span>
                              </span>
                          </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
      </Fragment>
    );
  }
}

export default AttributeSize;

  